var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"LeftAreaContainer"},[_c('ContentTop',{attrs:{"title":"人均体育场地面积排行","topOptionsProps":_vm.cityActiveOptionProps,"type":2}}),_c('div',{staticClass:"rank-list",staticStyle:{"margin-top":"21px"}},[_c('rank-list',{attrs:{"listHeight":474,"tableTitle":_vm.tableTitle,"list":_vm.areaData}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }